import React, { FC, ReactElement, useCallback, useEffect, useState } from "react";
import Cookies from "js-cookie";
import apiGetFromAuth from "../../../api-controller-mod/api-serv/get-api/getApiFromAuth";
import { useCookies } from "../../../context-controller-mod/context-serv/global-provider/cookies-context/cookiesContext";
import { API_ENDPOINTS } from "../../../context-controller-mod/context-serv/global-provider/api-shell/api-provider";

interface PrivateRouteProps {
  children: ReactElement;
  loginUrl: string;
}

export const PrivateRoute: FC<PrivateRouteProps> = ({ children, loginUrl }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(!!Cookies.get("access_token"));
  const [loading, setLoading] = useState(true);

  const { authCook } = useCookies();

  const fetchVerifyToken = useCallback(async () => {
    setLoading(true);

    try {
      const response = await apiGetFromAuth(API_ENDPOINTS.GET_VERIFY_TOKEN);
      if (response.status === 200) {
        const newToken = response?.data?.data?.access_token;
        authCook({ tokenPass: newToken });

        // Update state so PrivateRoute re-renders with updated auth status
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }

    } catch (err) {
      console.error("Failed to verify token:", err);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  }, [authCook]);

  useEffect(() => {
    fetchVerifyToken();
  }, [fetchVerifyToken]);

  // Wait for verify() to finish
  if (loading) return null;

  // Not authenticated → redirect
  if (!isAuthenticated) {
    const currentUrl = globalThis.window.location.href;
    const redirectUrl = `${loginUrl}?redirect_uri=${encodeURIComponent(currentUrl)}`;
    globalThis.window.location.href = redirectUrl;
    return null;
  }

  return children;
};
